var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",staticStyle:{"height":"100vh","max-height":"100vh"},attrs:{"fluid":"","id":"sexperimenter"}},[_c('touch-me-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }